module.exports = __webpack_public_path__ + "img/collection-weddingRingsForestGreen.4d8ab16.webp";